<script lang="ts">
  import Icon from './Icon.svelte';
  import Text from './Text.svelte';

  type Size = 'small' | 'large';

  export let label: string;
  export let isOpen: boolean;
  export let size: Size = 'small';
  export let onClose: () => void = () => {};

  const close = () => {
    isOpen = false;
  };

  const handleKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  $: {
    if (isOpen === false) {
      onClose();
    }
  }
</script>

<svelte:window
  on:keydown={e => {
    if (isOpen) handleKeydown(e);
  }}
/>

{#if isOpen}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="background" on:click|self={close} on:keydown={handleKeydown}>
    <div class="modal {size}">
      <div class="head">
        <Text size="large">{label}</Text>
        <button class="close" on:click={close}>
          <Icon variant="close" size="large" />
        </button>
      </div>
      <div class="body">
        <slot name="fixed" />
        <div class="content-wrapper">
          <div class="content">
            <slot />
          </div>
        </div>
        <div class="button-group">
          <slot name="button" />
        </div>
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';
  @use '../styles/font-sizes';

  .background {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    inset: 0;
    backdrop-filter: blur(1px);
    background-color: colors.$black30;
  }

  .modal {
    display: inline-block;
    min-width: 360px;
    width: 45vw;
    max-height: calc(100vh - spacing.$m);
    background-color: colors.$white100;
    border-radius: 4px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;

    &.large {
      width: 80vw;
    }
  }

  .head {
    position: relative;
    padding: spacing.$s spacing.$m;
    border-bottom: 1px solid colors.$black10;
  }

  .close {
    position: absolute;
    right: 10px;
    top: 10px;

    &:hover {
      cursor: pointer;
    }
  }

  .body {
    padding: spacing.$m;
    display: flex;
    flex-direction: column;
    gap: spacing.$m;

    .content-wrapper {
      max-height: 54vh;
      overflow-y: auto;
      overscroll-behavior: contain;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: spacing.$m;
    }

    .button-group {
      text-align: end;
    }
  }
</style>
